import { useState, useRef, useEffect } from 'react';
import useApi from "./useApi";

function useBom () {
    const [generatedBom, setGeneratedBom] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const bomGenerationApi = useApi('Bom');
    const bomGenerationLoad = useRef(true);

    useEffect(() => {
        if (bomGenerationLoad.current) {
            bomGenerationLoad.current = false;
            return;
        }

        setGeneratedBom(bomGenerationApi.data);
        setLoading(bomGenerationApi.loading);
        setError(bomGenerationApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bomGenerationApi]);

    const generateBom = async (image, prompt) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("Image", image);
        formData.append("Prompt", prompt);

        bomGenerationApi.post(formData, {headers: {'Accept': 'multipart/form-data'}});
    }

    return {
        generatedBom,
        error,
        loading,
        generateBom
    };
}

export default useBom;